import ownerReportingIcon from '../assets/owner-reporting.png';

/**
 * In-repo product icons keyed by marketplace product code.
 * Apps can later declare iconKey in manifest; FE resolves here (no remote loading).
 */
const PRODUCT_ICONS = {
  'owner-reporting': ownerReportingIcon,
};

export const getProductIcon = product => {
  if (!product) return null;
  if (product.iconUrl) return product.iconUrl;
  if (product.iconKey && PRODUCT_ICONS[product.iconKey]) return PRODUCT_ICONS[product.iconKey];
  return PRODUCT_ICONS[product.code] || null;
};

export default PRODUCT_ICONS;
